/**
 * مجالسنا - ملف التكوين الرئيسي
 * 
 * يحتوي هذا الملف على إعدادات التكوين العامة للتطبيق.
 * تمركز التكوين هنا يجعل من السهل تعديل سلوك التطبيق.
 */

const config = {
  // معلومات التطبيق
  app: {
    name: 'مجالسنا',
    version: '1.0.0',
    description: 'نظام ترشيح المرشحين',
    logoPath: '/assets/logo.png',
    direction: 'rtl', // اتجاه النص من اليمين إلى اليسار
    language: 'ar', // اللغة العربية
  },
  
  // هيكل المنظمة
  organization: {
    headquarters: {
      id: 'hq',
      name: 'الإدارة الرئيسية',
    },
    branches: [
      { id: 'makkah', name: 'فرع العاصمة المقدسة' },
      { id: 'taif', name: 'فرع الطائف' },
      { id: 'jeddah', name: 'فرع جدة' },
    ],
    centers: [
      // مراكز فرع العاصمة المقدسة
      { id: 'mk-01', name: 'مركز حي العتيبية', branchId: 'makkah' },
      { id: 'mk-02', name: 'مركز حي الشرائع', branchId: 'makkah' },
      { id: 'mk-03', name: 'مركز حي العمرة', branchId: 'makkah' },
      { id: 'mk-04', name: 'مركز حي الرصيفة', branchId: 'makkah' },
      { id: 'mk-05', name: 'مركز حي العزيزية', branchId: 'makkah' },
      { id: 'mk-06', name: 'مركز حي المسفلة', branchId: 'makkah' },
      { id: 'mk-07', name: 'مركز حي الهجرة', branchId: 'makkah' },
      { id: 'mk-08', name: 'مركز حي العوالي', branchId: 'makkah' },
      { id: 'mk-09', name: 'مركز حي المعابدة', branchId: 'makkah' },
      { id: 'mk-10', name: 'مركز حي الملك فهد', branchId: 'makkah' },
      { id: 'mk-11', name: 'مركز حي المنصور', branchId: 'makkah' },
      { id: 'mk-12', name: 'مركز حي جعرانة', branchId: 'makkah' },
      { id: 'mk-13', name: 'مركز حي الحمراء', branchId: 'makkah' },
      { id: 'mk-14', name: 'مركز حي أجياد', branchId: 'makkah' },
      { id: 'mk-15', name: 'مركز حي الفيحاء', branchId: 'makkah' },
      { id: 'mk-16', name: 'مركز حي وادي جليل', branchId: 'makkah' },
      { id: 'mk-17', name: 'مركز حي النزهة', branchId: 'makkah' },
      { id: 'mk-18', name: 'مركز حي الزهراء', branchId: 'makkah' },
      { id: 'mk-19', name: 'مركز حي العسيلة', branchId: 'makkah' },
      { id: 'mk-20', name: 'مركز حي الهنداوية', branchId: 'makkah' },
      { id: 'mk-21', name: 'مركز حي النوارية', branchId: 'makkah' },
      { id: 'mk-22', name: 'مركز حي ولي العهد', branchId: 'makkah' },
      
      // مراكز فرع الطائف
      { id: 'tf-01', name: 'مركز حي اليمانية والبلد', branchId: 'taif' },
      { id: 'tf-02', name: 'مركز حي شهار', branchId: 'taif' },
      { id: 'tf-03', name: 'مركز حي قروى', branchId: 'taif' },
      { id: 'tf-04', name: 'مركز حي الملك فهد', branchId: 'taif' },
      { id: 'tf-05', name: 'مركز حي أم السباع', branchId: 'taif' },
      { id: 'tf-06', name: 'مركز حي الحلقة', branchId: 'taif' },
      { id: 'tf-07', name: 'مركز حي الهدا', branchId: 'taif' },
      { id: 'tf-08', name: 'مركز حي الحوية', branchId: 'taif' },
      { id: 'tf-09', name: 'مركز حي دغبج', branchId: 'taif' },
      { id: 'tf-10', name: 'مركز حي عشيرة', branchId: 'taif' },
      { id: 'tf-11', name: 'مركز حي الهدا', branchId: 'taif' },
      { id: 'tf-12', name: 'مركز حي العرفاء', branchId: 'taif' },
      
      // مراكز فرع جدة
      { id: 'jd-01', name: 'مركز حي الحمدانية', branchId: 'jeddah' },
      { id: 'jd-02', name: 'مركز حي السامر', branchId: 'jeddah' },
      { id: 'jd-03', name: 'مركز حي أبحر', branchId: 'jeddah' },
      { id: 'jd-04', name: 'مركز حي الأمير فواز', branchId: 'jeddah' },
      { id: 'jd-05', name: 'مركز حي السامر', branchId: 'jeddah' },
      { id: 'jd-06', name: 'مركز حي الشاطئ', branchId: 'jeddah' },
      { id: 'jd-07', name: 'مركز حي الصفا النموذجي', branchId: 'jeddah' },
      { id: 'jd-08', name: 'مركز حي المحمدية النموذجي', branchId: 'jeddah' },
      { id: 'jd-09', name: 'مركز حي النزلة', branchId: 'jeddah' },
      { id: 'jd-10', name: 'مركز حي النسيم', branchId: 'jeddah' },
      { id: 'jd-11', name: 'مركز حي النهضة النموذجي', branchId: 'jeddah' },
      { id: 'jd-12', name: 'مركز حي البساتين', branchId: 'jeddah' },
      { id: 'jd-13', name: 'مركز حي الشرفية', branchId: 'jeddah' },
      { id: 'jd-14', name: 'مركز حي الروضة', branchId: 'jeddah' },
      { id: 'jd-15', name: 'مركز حي السليمانية', branchId: 'jeddah' },
      { id: 'jd-16', name: 'مركز حي النعيم', branchId: 'jeddah' },
      { id: 'jd-17', name: 'مركز حي الخمرة', branchId: 'jeddah' },
      { id: 'jd-18', name: 'مركز حي طيبة', branchId: 'jeddah' },
    ],
  },
  
  // أدوار المستخدمين
  roles: {
    ADMIN: 'admin',
    COMMITTEE: 'committee',
    CANDIDATE: 'candidate',
  },
  
  // تكوين حقول النماذج
  forms: {
    candidate: {
      // Step 1: Personal Information
      personalInfo: [
        { id: 'firstName', label: 'الاسم الأول', type: 'text', required: true },
        { id: 'lastName', label: 'اسم العائلة', type: 'text', required: true },
        { id: 'email', label: 'البريد الإلكتروني', type: 'email', required: true },
        { id: 'phone', label: 'رقم الهاتف', type: 'tel', required: true },
        { id: 'nationalId', label: 'رقم الهوية الوطنية', type: 'text', required: true },
        { id: 'birthDate', label: 'تاريخ الميلاد', type: 'date', required: true },
        { id: 'city', label: 'المدينة', type: 'text', required: true },
        { id: 'district', label: 'الحي', type: 'text', required: true },
        { id: 'street', label: 'الشارع', type: 'text', required: true },
        { id: 'buildingNumber', label: 'رقم المبنى', type: 'text', required: true },
        { id: 'postalCode', label: 'الرمز البريدي', type: 'text', required: true },
        { id: 'membershipStatus', label: 'حالة العضوية', type: 'select', options: ['new', 'existing'], required: true },
      ],
      // Step 2: Documents
      documents: [
        { id: 'personalPhoto', label: 'الصورة الشخصية', type: 'file', accept: 'image/*', required: true },
        { id: 'securityClearance', label: 'وثيقة الفسح الأمني', type: 'file', accept: '.pdf,.doc,.docx,.jpg,.png', required: true },
        { id: 'cv', label: 'السيرة الذاتية', type: 'file', accept: '.pdf,.doc,.docx', required: true },
        { id: 'additionalDocuments', label: 'مستندات إضافية', type: 'file', accept: '.pdf,.doc,.docx,.jpg,.png', multiple: true, required: false },
      ],
      // Step 3: Nomination
      nomination: [
        { id: 'branch', label: 'الفرع', type: 'select', dynamicOptions: 'branches', required: true },
        { id: 'center', label: 'المركز', type: 'select', dynamicOptions: 'centers', required: true },

        { id: 'associationKnowledge', label: 'المعرفة بالجمعية', type: 'textarea', required: true },
        { id: 'socialResponsibility', label: 'المساهمة في المسؤولية الاجتماعية', type: 'textarea', required: true },
        { id: 'vision2030Programs', label: 'المساهمة في برامج رؤية 2030', type: 'textarea', required: true },
        { id: 'centerIncomeIdeas', label: 'أفكار لزيادة دخل المركز', type: 'textarea', required: true },
        { id: 'readRegulations', label: 'قراءة اللوائح', type: 'boolean', required: true },
        { id: 'confirmResponsibilities', label: 'تأكيد المسؤوليات', type: 'boolean', required: true },
        { id: 'acceptTerms', label: 'قبول الشروط والأحكام', type: 'boolean', required: true },
      ],
    },
  },
  
  // إعدادات الصفحات
  pagination: {
    itemsPerPage: 10,
    maxPagesShown: 5,
  },
  
  // تنسيق التاريخ
  dateFormat: 'YYYY-MM-DD',
  
  // حدود رفع الملفات
  uploads: {
    maxFileSize: 5 * 1024 * 1024, // 5MB
    allowedImageTypes: ['image/jpeg', 'image/png', 'image/gif'],
    allowedDocumentTypes: ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
  },
};

export default config;
